var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRuble = function SvgRuble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#FFC043"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    fillRule: "evenodd",
    d: "M13.7969 7C14.6463 7.00001 15.4609 7.33513 16.0615 7.93164C16.6622 8.52831 17 9.33783 17 10.1816C17 11.0255 16.6622 11.8349 16.0615 12.4316C15.4608 13.0283 14.6463 13.3633 13.7969 13.3633H11.2031V14H13V16H11.2031V18H9.37305V16H8V14H9.37305V13.3633H8V11.5459H9.37305V7H13.7969ZM11.2031 11.5459H13.7969C14.1609 11.5459 14.5102 11.4021 14.7676 11.1465C15.025 10.8908 15.1699 10.5433 15.1699 10.1816C15.1699 9.8201 15.0249 9.47345 14.7676 9.21777C14.5423 8.99404 14.2468 8.85622 13.9326 8.8252L13.7969 8.81836H11.2031V11.5459Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    fillRule: "evenodd",
    d: "M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84306 4.84248 6.34277 6.34277C4.84248 7.84306 4 9.87827 4 12C4 14.1217 4.84248 16.1569 6.34277 17.6572C7.84306 19.1575 9.87827 20 12 20C14.1217 20 16.1569 19.1575 17.6572 17.6572C19.1575 16.1569 20 14.1217 20 12C20 9.87827 19.1575 7.84306 17.6572 6.34277C16.1569 4.84248 14.1217 4 12 4Z",
    clipRule: "evenodd"
  })));
};
export default SvgRuble;